import React from 'react';
import { withStyles,
  Fade,
  Avatar,
  Typography,
  Button,
  Slide,
  IconButton,
  FormControl,
  Paper,
  TextField } from '@material-ui/core';
import Search from '@material-ui/icons/Search';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import { Link } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import MUIDataTable from 'mui-datatables';
import LinearProgressBlockScreen from '../share/LinearProgressBlockScreen';
import VariantSnackbar from '../share/VariantSnackbar';
import { format } from 'date-fns';
import CalculoCoparticipacaoService from '../../services/CalculoCoparticipacaoService';
import DialogErrosDemonstrativos from './DialogErrosDemonstrativos';
import ToolbarDemonstrativoSelectOdonto from './ToolbarDemonstrativoSelectOdonto';

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit,
  },
  titlebar: {
    display: 'flex',
    alignItems: 'center',
  },
  container: {
    display: 'block',
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 220,
  },
  textField: {
    marginLeft: theme.spacing.unit,
    width: 450,
  },
  button: {
    marginLeft: theme.spacing.unit * 2,
  },
  searchIcon: {
    marginLeft: theme.spacing.unit,
  },
  input: {
    margin: theme.spacing.unit,
  },
  link: {
    textDecoration: 'none',
  },
  body: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  avatar: {
    marginLeft: '20px'
  },
  tableRowCancelado: {
    backgroundColor: '#f2dede',
  },
  fontTable: {
    fontSize: 12
  },
});
@inject('aplicacaoStore')
@observer
class CalculoCoparticipacaoOdonto extends React.Component {
  calculoCoparticipacaoService = new CalculoCoparticipacaoService();
  state = {
    demonstrativos: [],
    numDemonstrativoSelected: '',
    fetching: false,
    buscarDisabled: true,
    snackOpen: false,
    snackVariant: 'success',
    snackHorizontal: 'right',
    snackMessage: '',
    sucesso: true,
    demonstrativosSemErros: [],
    dialogTitle: '',
    dialogContent: []
  }
  componentDidMount = async () => {
    this.setState({fetching: true});
    await this.consultarDemonstrativosNaoPagos();
    this.setState({fetching: false});
  }
  consultarDemonstrativosNaoPagos = async () => {
    this.setState({fetching: true});
    let demonstrativos = await this.calculoCoparticipacaoService.consultarDemonstrativosNaoPagosOdonto(this.state.numDemonstrativoSelected === '' ? 0 : this.state.numDemonstrativoSelected);
    this.setState({demonstrativos: demonstrativos, fetching: false});
  }
  handleChangeTextField = event => {
    var valorNovo = event.target.value.replace(/[^\d.-/-]/g, '').substring(0, 6);
    this.setState({ [event.target.name]: valorNovo, buscarDisabled: event.target.value === '' });
  };
  handleClickBuscar = async (event) => {
    event.preventDefault();
    await this.consultarDemonstrativosNaoPagos();
  }
  handleClickLancar = async (event) => {
    event.preventDefault();
    this.setState({fetching: true});
    let conteudoXml = await this.calculoCoparticipacaoService.lancarCoparticipacao();

    const url = window.URL.createObjectURL(new Blob([conteudoXml.data.body.content]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'RESULT_LANC.html');
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
    this.setState({fetching: false});
  }
  onOperacaoFinalizadaDialog = async (result) => {
    if (result === undefined || result === null) {
      this.setState({snackOpen: true, snackMessage: 'Não foi possível realizar a operação.', fetching: false, sucesso: false});
    } else {
      this.setState({openDialogValidacao: true,
        dialogContent: result.registrosComErros,
        dialogTitle: result.msgRetornoResumida,
        demonstrativosSemErros: result.registrosSemErros,
        fetching: false,
        sucesso: false});
    }
    this.setState({fetching: false, prestadorSelecionado: {}});
    await this.consultarDemonstrativosNaoPagos();
  }
  handleCloseSnackbar = () => {
    this.setState({ snackOpen: false });
  }
  handleCloseDialogValidacao = () => {
    this.setState({ openDialogValidacao: false });
  };
  handleClickToolBar = () => {
    // this.setState({ fetching: true });
  }
  render () {
    const options = {
      customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
        <ToolbarDemonstrativoSelectOdonto
          handleClickToolBar={this.handleClickToolBar}
          selectedRows={selectedRows}
          displayData={displayData}
          setSelectedRows={setSelectedRows}
          onOperacaoFinalizada={this.onOperacaoFinalizadaDialog}
        />
      ),
      print: false,
      download: false,
      selectableRows: true,
      filterType: 'dropdown',
      rowsPerPageOptions: [5, 10, 15],
      rowsPerPage: 10,
      textLabels: {
        body: {
          noMatch: 'Nenhum registro encontrado',
          toolTip: 'Ordenar',
        },
        pagination: {
          next: 'Próxima página',
          previous: 'Página anterior',
          rowsPerPage: 'Registros por página:',
          displayRows: 'de',
        },
        toolbar: {
          search: 'Procurar',
          viewColumns: 'Ver Colunas',
          filterTable: 'Filtrar',
        },
        filter: {
          all: 'Todos',
          title: 'FILTROS',
          reset: 'RESET',
        },
        viewColumns: {
          title: 'Mostrar Colunas',
          titleAria: 'Exibir/Ocultar Colunas',
        },
        selectedRows: {
          text: <Typography style={{display: 'inline', fontFamily: 'Roboto'}}>faixa(s) selecionada(s)</Typography>,
        },
      }
    };
    const columns = [
      {
        name: 'Número',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography style={{fontSize: 12}}>{value}</Typography>;
          },
        }
      },
      {
        name: 'Data Emissão',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography style={{fontSize: 12}}>{format(new Date(value), 'DD/MM/YYYY')}</Typography>;
          },
        }
      },
      {
        name: 'codPrestador',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'Prestador',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography style={{fontSize: 12}}>{value}</Typography>;
          },
        }
      },
      {
        name: 'cnpjPrestador',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'Total Processado',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            const nf = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            return <Typography className={classes.fontTable}>{nf.format(value)}</Typography>;
          },
          setCellProps: () => {
            return {
              className: classes.fontTable
            };
          },
        },
      },
      {
        name: 'Total Liberado',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            const nf = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            return <Typography className={classes.fontTable} color='primary'>{nf.format(value)}</Typography>;
          },
          setCellProps: () => {
            return {
              className: classes.fontTable
            };
          },
        }
      },
      {
        name: 'Total Glosado',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            const nf = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            return <Typography className={classes.fontTable} color='error'>{nf.format(value)}</Typography>;
          },
          setCellProps: () => {
            return {
              className: classes.fontTable
            };
          },
        }
      },
    ];

    const { classes } = this.props;
    const { fetching, demonstrativos } = this.state;
    return (
      <React.Fragment>
        <Link to='/financeiro' className={classes.link}>
          <Slide direction='down' timeout={600} in>
            <Paper elevation={1} className={classes.titlebar}>
              <IconButton color='inherit' aria-label='Close'>
                <ChevronLeft />
              </IconButton>
              <Typography variant='headline'>Cálculo de Coparticipação - Odontológico (Demonstrativos de Pagamento Não Lançados em Folha)</Typography>
              {demonstrativos && <Avatar className={classes.avatar}>{demonstrativos.length}</Avatar>}
            </Paper>
          </Slide>
        </Link>
        <Paper className={classes.root} elevation={1}>
          <form className={classes.container} noValidate>
            <FormControl className={classes.formControl}>
              <TextField
                value={(this.state.numDemonstrativoSelected === null || this.state.numDemonstrativoSelected === undefined) ? '' : this.state.numDemonstrativoSelected}
                className={classes.textField}
                margin='dense'
                id='numDemonstrativoSelected'
                name='numDemonstrativoSelected'
                placeholder='Pesquise pelo Número...'
                fullWidth
                onChange={this.handleChangeTextField}
              />
            </FormControl>
            <Button
              variant='extendedFab'
              title='Consultar'
              type='submit'
              onTouchStart={this.handleClickBuscar}
              onClick={this.handleClickBuscar}
              className={classes.button}>
              <Search className={classes.searchIcon} />
              Buscar
            </Button>
            {/* <Button
              variant='extendedFab'
              title='Lançar em folha !!!!'
              type='submit'
              onTouchStart={this.handleClickLancar}
              onClick={this.handleClickLancar}
              className={classes.button}>
              <Rowing className={classes.searchIcon} />
              Lançar em folha !!!!
            </Button> */}
          </form>
        </Paper>
        {fetching ? <LinearProgressBlockScreen />
          : <Fade timeout={1000} in>
            <Paper className={classes.body} elevation={1}>
              <MUIDataTable
                data={demonstrativos}
                columns={columns}
                options={options}
              />
            </Paper>
          </Fade>
        }
        <VariantSnackbar
          vertical={'top'}
          horizontal={'right'}
          variant={this.state.sucesso ? 'success' : 'error'}
          message={this.state.snackMessage}
          open={this.state.snackOpen}
          handleClose={this.handleCloseSnackbar} />
        {this.state.openDialogValidacao &&
          <DialogErrosDemonstrativos
            open={this.state.openDialogValidacao}
            handleClose={this.handleCloseDialogValidacao}
            erros={this.state.dialogContent}
            titulo={this.state.dialogTitle}
            demonstrativosSemErros={this.state.demonstrativosSemErros}
            mensagemComplementar={'foi(ram) calculado(s) com sucesso.'}
          />}
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(CalculoCoparticipacaoOdonto);
